import React from 'react'

import filter from 'lodash/filter'

import Edit from './MenuItems/Edit'
import MoveTo from './MenuItems/MoveTo'
import Remove from './MenuItems/Remove'
import RemovePageProfile from './MenuItems/RemovePageProfile'
import Statistics from './MenuItems/Statistics'

export const getMenuItems = (
  { id, slug, canManage, __typename, visibility, parent_folder_id },
  removePositionTop,
  userIsCreator,
  path?
) => {
  const isFolderPage = path ? /^\/f\/[^/]+/.test(path) : false
  const isProfilePage = path ? /^\/profile(\/|$)/.test(path) : false

  return filter([
    removePositionTop && !isProfilePage && (userIsCreator || !isFolderPage) ? (
      <Remove
        canManage={canManage}
        id={id}
        key={`remove_${id}`}
        typename={__typename}
        visibility={visibility}
      />
    ) : null,
    userIsCreator && isProfilePage ? (
      <RemovePageProfile id={id} typename={__typename} />
    ) : null,
    Boolean(canManage) ? <Edit key={`edit_${id}`} id={id} /> : null,
    userIsCreator && __typename !== 'Folder' ? (
      <MoveTo
        key={`move_${id}`}
        element={{ id, __typename, parent_folder_id, visibility }}
      />
    ) : null,
    canManage && <Statistics key={`statistics_${slug}`} slug={slug} />,
    !removePositionTop && !isProfilePage ? (
      <Remove
        canManage={canManage}
        id={id}
        key={`remove_${id}`}
        typename={__typename}
        visibility={visibility}
      />
    ) : null,
  ])
}
